import mod from "-!./Categories.js?vue&type=script&lang=js&external"; export default mod; export * from "-!./Categories.js?vue&type=script&lang=js&external"